export default "__VITE_ASSET__yx4eyXPd__"